import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuGroup,
  ContextMenuItem,
  ContextMenuShortcut,
  ContextMenuTrigger,
} from '@flatfile/baseline'
import { useTranslation } from 'react-i18next'

interface TableContextMenuProps {
  children: React.ReactNode
  handleCopy: (e: React.MouseEvent<HTMLElement>) => void
  handlePaste: (e: React.MouseEvent<HTMLElement>) => void
  handleCut: (e: React.MouseEvent<HTMLElement>) => void
  onOpenChange: (open: boolean) => void
  editingEnabled?: boolean
  cellId: string
  isFocused: boolean
}

export const CellContextMenu = ({
  children,
  handleCopy,
  handlePaste,
  handleCut,
  onOpenChange,
  editingEnabled,
  cellId,
  isFocused,
}: TableContextMenuProps) => {
  const isMac = /Mac|iPod|iPhone|iPad/.test(navigator.userAgent)
  const { t } = useTranslation()

  const handleOpenChange = (open: boolean) => {
    onOpenChange(open)
  }

  return (
    <ContextMenu onOpenChange={handleOpenChange}>
      <ContextMenuTrigger>{children}</ContextMenuTrigger>
      <ContextMenuContent>
        <ContextMenuGroup>
          {editingEnabled && (
            <ContextMenuItem onClick={handleCut}>
              {t('cellContextMenu.cut')}
              <ContextMenuShortcut>
                {isMac ? '⌘X' : 'Ctrl+X'}
              </ContextMenuShortcut>
            </ContextMenuItem>
          )}
          <ContextMenuItem onClick={handleCopy}>
            {t('cellContextMenu.copy')}
            <ContextMenuShortcut>{isMac ? '⌘C' : 'Ctrl+C'}</ContextMenuShortcut>
          </ContextMenuItem>
          {editingEnabled && (
            <ContextMenuItem onClick={handlePaste}>
              {t('cellContextMenu.paste')}
              <ContextMenuShortcut>
                {isMac ? '⌘V' : 'Ctrl+V'}
              </ContextMenuShortcut>
            </ContextMenuItem>
          )}
        </ContextMenuGroup>
      </ContextMenuContent>
    </ContextMenu>
  )
}
